var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0317 2.625H8.8151C5.0351 2.625 2.39844 5.16833 2.39844 8.80833V12.4833C2.39844 12.6766 2.55513 12.8333 2.74844 12.8333H24.2151C24.4084 12.8333 24.5651 12.6766 24.5651 12.4833V8.80833C24.5651 5.11 21.9401 2.625 18.0317 2.625Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.678 15.3375C15.9487 15.1035 15.7926 14.583 15.4349 14.583H2.74844C2.55513 14.583 2.39844 14.7397 2.39844 14.933V18.608C2.39844 22.3063 4.97677 24.7913 8.8151 24.7913H14.0485C14.342 24.7913 14.5111 24.4467 14.3538 24.199C13.6801 23.1376 13.2951 21.8722 13.2951 20.533C13.2951 18.4563 14.2206 16.5976 15.678 15.3375Z",
    fill: "#484848"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8505 9.2168H13.6005C13.1221 9.2168 12.7255 8.82013 12.7255 8.3418C12.7255 7.86346 13.1221 7.4668 13.6005 7.4668H18.8505C19.3405 7.4668 19.7255 7.86346 19.7255 8.3418C19.7255 8.82013 19.3405 9.2168 18.8505 9.2168ZM8.70052 9.2168H8.11719C7.63885 9.2168 7.24219 8.82013 7.24219 8.3418C7.24219 7.86346 7.63885 7.4668 8.11719 7.4668H8.70052C9.19052 7.4668 9.57552 7.86346 9.57552 8.3418C9.57552 8.82013 9.19052 9.2168 8.70052 9.2168Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70052 19.9512H8.11719C7.63885 19.9512 7.24219 19.5545 7.24219 19.0762C7.24219 18.5978 7.63885 18.2012 8.11719 18.2012H8.70052C9.19052 18.2012 9.57552 18.5978 9.57552 19.0762C9.57552 19.5545 9.19052 19.9512 8.70052 19.9512Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7577 23.6247C20.2478 23.6247 19.7777 23.4964 19.3588 23.2864L23.511 19.1342C23.721 19.5531 23.8493 20.0232 23.8493 20.5331C23.8493 22.2667 22.4913 23.6247 20.7577 23.6247ZM20.7577 17.4414C21.3293 17.4414 21.8532 17.6012 22.3082 17.8614L18.086 22.0847C17.8258 21.6297 17.666 21.1059 17.666 20.5331C17.666 18.7994 19.024 17.4414 20.7577 17.4414ZM20.7577 15.6914C18.0428 15.6914 15.916 17.8182 15.916 20.5331C15.916 23.2479 18.0428 25.3747 20.7577 25.3747C23.4725 25.3747 25.5993 23.2479 25.5993 20.5331C25.5993 17.8182 23.4725 15.6914 20.7577 15.6914Z",
    fill: "#DB2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/Blocked.da54b84d9efe0be7b714f1e795ece4cf.svg";
export { ForwardRef as ReactComponent };